import Link from '@mui/material/Link';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useNavigate, useLocation } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import HistoryIcon from '@mui/icons-material/History';
import BusinessIcon from '@mui/icons-material/Business';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import TrendingDownOutlinedIcon from '@mui/icons-material/TrendingDownOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';

const drawerWidth = 250;

const ResponsiveDrawer = ({ setLoggedIn, openMenu, toggleMenu }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userRole, setUserRole] = useState(null);

  // Check user role
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserRole(decodedToken.role);
    }
  }, []);

  const logOut = () => {
    localStorage.setItem('token', '');
    setLoggedIn(false);
    navigate('/login');
  }

  const handleNavigate = (path) => {
    navigate(path);
    toggleMenu(false)(); // Close menu after navigation on mobile
  }

  const drawer = (
    <List sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <ListItem
        key='homepage'
        component={Link}
        onClick={() => handleNavigate('/')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/'}>
          <ListItemIcon sx={{ color: location.pathname === '/' ? 'primary.main' : 'inherit' }}>
            <HomeOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Trang Chủ' />
        </ListItemButton>
      </ListItem>
      <ListItem
        key='check-in-history'
        component={Link}
        onClick={() => handleNavigate('/check-in-history')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/check-in-history'}>
          <ListItemIcon sx={{ color: location.pathname === '/check-in-history' ? 'primary.main' : 'inherit' }}>
            <HistoryIcon />
          </ListItemIcon>
          <ListItemText primary='Lịch sử điểm danh' />
        </ListItemButton>
      </ListItem>
      <ListItem
        key='scheduled-alerts'
        component={Link}
        onClick={() => handleNavigate('/scheduled-alerts')}
        disablePadding
      >
        <ListItemButton selected={location.pathname.startsWith('/scheduled-alerts')}>
          <ListItemIcon sx={{ color: location.pathname.startsWith('/scheduled-alerts') ? 'primary.main' : 'inherit' }}>
            <NotificationsOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Nhắc nhở' />
        </ListItemButton>
      </ListItem>
      <ListItem
        key='dev-tickets'
        component={Link}
        onClick={() => handleNavigate('/dev-tickets')}
        disablePadding
      >
        <ListItemButton selected={location.pathname.startsWith('/dev-tickets')}>
          <ListItemIcon sx={{ color: location.pathname.startsWith('/dev-tickets') ? 'primary.main' : 'inherit' }}>
            <BugReportOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Yêu cầu phát triển' />
        </ListItemButton>
      </ListItem>
      <ListItem
        key='customers'
        component={Link}
        onClick={() => handleNavigate('/customers')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/customers'}>
          <ListItemIcon sx={{ color: location.pathname === '/customers' ? 'primary.main' : 'inherit' }}>
            <PeopleAltOutlinedIcon />
          </ListItemIcon >
          <ListItemText primary='Khách Hàng' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='invoices'
        component={Link}
        onClick={() => handleNavigate('/invoices')}
        disablePadding
      >
        <ListItemButton selected={location.pathname.startsWith('/invoices')}>
          <ListItemIcon sx={{ color: location.pathname.startsWith('/invoices') ? 'primary.main' : 'inherit' }}>
            <ReceiptLongOutlinedIcon />
          </ListItemIcon >
          <ListItemText primary='Hóa đơn' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='inactive-users'
        component={Link}
        onClick={() => handleNavigate('/users/inactive')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/users/inactive'}>
          <ListItemIcon sx={{ color: location.pathname === '/users/inactive' ? 'primary.main' : 'inherit' }}>
            <PeopleAltOutlinedIcon />
          </ListItemIcon >
          <ListItemText primary='Khách hàng không hoạt động' />
        </ListItemButton >
      </ListItem >
      {/* Suppliers - Only for ADMIN */}
      {userRole === 'ADMIN' && (
        <ListItem
          key='suppliers'
          component={Link}
          onClick={() => handleNavigate('/suppliers')}
          disablePadding
        >
          <ListItemButton selected={location.pathname.startsWith('/suppliers')}>
            <ListItemIcon sx={{ color: location.pathname.startsWith('/suppliers') ? 'primary.main' : 'inherit' }}>
              <BusinessIcon />
            </ListItemIcon>
            <ListItemText primary='Nhà cung cấp' />
          </ListItemButton >
        </ListItem >
      )}
      {/* Purchase Orders - For both ADMIN and STAFF */}
      <ListItem
        key='purchase-orders'
        component={Link}
        onClick={() => handleNavigate('/purchase-orders')}
        disablePadding
      >
        <ListItemButton selected={location.pathname.startsWith('/purchase-orders')}>
          <ListItemIcon sx={{ color: location.pathname.startsWith('/purchase-orders') ? 'primary.main' : 'inherit' }}>
            <ReceiptLongOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Đơn đặt hàng' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='staffs'
        component={Link}
        onClick={() => handleNavigate('/staffs')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/staffs'}>
          <ListItemIcon sx={{ color: location.pathname === '/staffs' ? 'primary.main' : 'inherit' }}>
            <GroupOutlinedIcon />
          </ListItemIcon >
          <ListItemText primary='Danh sách nhân viên' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='work-schedules'
        component={Link}
        onClick={() => handleNavigate('/work-schedules')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/work-schedules'}>
          <ListItemIcon sx={{ color: location.pathname === '/work-schedules' ? 'primary.main' : 'inherit' }}>
            <CalendarMonthOutlinedIcon />
          </ListItemIcon >
          <ListItemText primary='Lịch làm việc' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='my-schedule'
        component={Link}
        onClick={() => handleNavigate('/my-schedule')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/my-schedule'}>
          <ListItemIcon sx={{ color: location.pathname === '/my-schedule' ? 'primary.main' : 'inherit' }}>
            <EventNoteOutlinedIcon />
          </ListItemIcon >
          <ListItemText primary='Lịch của tôi' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='change_password'
        component={Link}
        onClick={() => handleNavigate('/changepassword')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/changepassword'}>
          <ListItemIcon sx={{ color: location.pathname === '/changepassword' ? 'primary.main' : 'inherit' }}>
            <LockOutlinedIcon />
          </ListItemIcon >
          <ListItemText primary='Đổi mật khẩu' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='orders'
        component={Link}
        onClick={() => handleNavigate('/orders')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/orders'}>
          <ListItemIcon sx={{ color: location.pathname === '/orders' ? 'primary.main' : 'inherit' }}>
            <ShoppingCartOutlinedIcon />
          </ListItemIcon >
          <ListItemText primary='Đơn hàng' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='qr-scanner'
        component={Link}
        onClick={() => handleNavigate('/qr-scanner')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/qr-scanner'}>
          <ListItemIcon sx={{ color: location.pathname === '/qr-scanner' ? 'primary.main' : 'inherit' }}>
            <QrCodeScannerIcon />
          </ListItemIcon >
          <ListItemText primary='Quét mã QR' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='products'
        component={Link}
        onClick={() => handleNavigate('/products')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/products'}>
          <ListItemIcon sx={{ color: location.pathname === '/products' ? 'primary.main' : 'inherit' }}>
            <Inventory2OutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Sản phẩm' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='inventory_level_transactions'
        component={Link}
        onClick={() => handleNavigate('/inventory_level_transactions')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/inventory_level_transactions'}>
          <ListItemIcon sx={{ color: location.pathname === '/inventory_level_transactions' ? 'primary.main' : 'inherit' }}>
            <LocalShippingOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Nhập hàng' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='stocktakes'
        component={Link}
        onClick={() => handleNavigate('/stocktakes')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/stocktakes'}>
          <ListItemIcon sx={{ color: location.pathname === '/stocktakes' ? 'primary.main' : 'inherit' }}>
            <FactCheckOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Kiểm kho' />
        </ListItemButton >
      </ListItem >
      {/* <ListItem
        key='reports'
        component={Link}
        onClick={() => handleNavigate('/reports')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/reports'}>
          <ListItemIcon sx={{ color: location.pathname === '/reports' ? 'primary.main' : 'inherit' }}>
            <AssessmentOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Hàng tồn' />
        </ListItemButton >
      </ListItem > */}
      <ListItem
        key='order-items-report'
        component={Link}
        onClick={() => handleNavigate('/order-items-report')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/order-items-report'}>
          <ListItemIcon sx={{ color: location.pathname === '/order-items-report' ? 'primary.main' : 'inherit' }}>
            <AssessmentOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Báo cáo đơn hàng' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='order-count-report'
        component={Link}
        onClick={() => handleNavigate('/order-count-report')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/order-count-report'}>
          <ListItemIcon sx={{ color: location.pathname === '/order-count-report' ? 'primary.main' : 'inherit' }}>
            <BarChartOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Thống kê số đơn' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='order-staff-report'
        component={Link}
        onClick={() => handleNavigate('/order-staff-report')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/order-staff-report'}>
          <ListItemIcon sx={{ color: location.pathname === '/order-staff-report' ? 'primary.main' : 'inherit' }}>
            <PeopleAltOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Thống kê nhân viên' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='menus'
        component={Link}
        onClick={() => handleNavigate('/menus')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/menus' || location.pathname.startsWith('/menus/')}>
          <ListItemIcon sx={{ color: (location.pathname === '/menus' || location.pathname.startsWith('/menus/')) ? 'primary.main' : 'inherit' }}>
            <MenuBookOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Menu KH' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='menus-report'
        component={Link}
        onClick={() => handleNavigate('/menus-report')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/menus-report'}>
          <ListItemIcon sx={{ color: location.pathname === '/menus-report' ? 'primary.main' : 'inherit' }}>
            <AssessmentOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Báo cáo Menu' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='packages'
        component={Link}
        onClick={() => handleNavigate('/packages')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/packages'}>
          <ListItemIcon sx={{ color: location.pathname === '/packages' ? 'primary.main' : 'inherit' }}>
            <LocalOfferOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Gói dịch vụ' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='user-packages'
        component={Link}
        onClick={() => handleNavigate('/user-packages')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/user-packages'}>
          <ListItemIcon sx={{ color: location.pathname === '/user-packages' ? 'primary.main' : 'inherit' }}>
            <LocalOfferOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Gói dịch vụ của khách hàng' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='subscription-health'
        component={Link}
        onClick={() => handleNavigate('/subscription-health')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/subscription-health'}>
          <ListItemIcon sx={{ color: location.pathname === '/subscription-health' ? 'primary.main' : 'inherit' }}>
            <MonitorHeartOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Theo dõi gói dịch vụ' />
        </ListItemButton >
      </ListItem >
      <ListItem
        key='monthly-churn'
        component={Link}
        onClick={() => handleNavigate('/monthly-churn')}
        disablePadding
      >
        <ListItemButton selected={location.pathname === '/monthly-churn'}>
          <ListItemIcon sx={{ color: location.pathname === '/monthly-churn' ? 'primary.main' : 'inherit' }}>
            <TrendingDownOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Thống kê churn' />
        </ListItemButton >
      </ListItem >
      {userRole === 'ADMIN' && (
        <ListItem
          key='revenue-report'
          component={Link}
          onClick={() => handleNavigate('/revenue-report')}
          disablePadding
        >
          <ListItemButton selected={location.pathname === '/revenue-report'}>
            <ListItemIcon sx={{ color: location.pathname === '/revenue-report' ? 'primary.main' : 'inherit' }}>
              <MonetizationOnOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary='Báo cáo doanh thu' />
          </ListItemButton >
        </ListItem >
      )}
      {userRole === 'ADMIN' && (
        <ListItem
          key='bank-transactions'
          component={Link}
          onClick={() => handleNavigate('/bank-transactions')}
          disablePadding
        >
          <ListItemButton selected={location.pathname === '/bank-transactions'}>
            <ListItemIcon sx={{ color: location.pathname === '/bank-transactions' ? 'primary.main' : 'inherit' }}>
              <AccountBalanceOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary='Giao dịch ngân hàng' />
          </ListItemButton >
        </ListItem >
      )}
      <ListItem
        key='logout'
        disablePadding
        sx={{ mb: 3, mt: "auto" }}
      >
        <ListItemButton onClick={() => logOut()}>
          <ListItemIcon>
            <LogoutOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Logout' />
        </ListItemButton>
      </ListItem>
    </List >
  );

  return (
    <>
      {/* Desktop drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'none', md: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          bgcolor: 'primary.main',
        }}
        open
        className='vertical-menu'
      >
        {drawer}
      </Drawer>

      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={openMenu}
        onClose={toggleMenu(false)}
        ModalProps={{
          keepMounted: true, // Better mobile performance
        }}
        sx={{
          display: { xs: 'block', sm: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          bgcolor: 'primary.main',
        }}
        className='vertical-menu'
      >
        {drawer}
      </Drawer>
    </>
  );
}

export default ResponsiveDrawer;
